import type { FilterSpec } from './types';

export function labelForOption(spec: FilterSpec, raw: string): string {
  const opt = spec.options?.find((option) => option.value === raw);
  return opt?.label ?? raw;
}
